import Vue from 'vue'
import Router from 'vue-router'
import MenuView from '@/views/common/MenuView'
import PageView from '@/views/common/PageView'
import LoginView from '@/views/login/Common'
import EmptyPageView from '@/views/common/EmptyPageView'
import HomePageView from '@/views/HomePage'
import db from 'utils/localstorage'
import request from 'utils/request'

Vue.use(Router)
//路由导航冗余报错（路由重复）
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
let constRouter = [
  // {
  //   path: '/login',
  //   name: '登录页',
  //   component: LoginView
  // },
  // {
  //   path: '/index',
  //   name: '首页',
  //   redirect: '/home'
  // },
  {
    path: '/mobile/upload/full/list',
    name: '上传全量清单',
    component: () => import('@/views/mobile/UploadFullList')
  },
  {
    path: '/mobile/upload/project/list',
    name: '上传移交清单',
    component: () => import('@/views/mobile/UploadProjectList')
  },
]

let router = new Router({
  routes: constRouter
})

const whiteList = ['/login']

let asyncRouter

// 导航守卫，渲染动态路由
router.beforeEach((to, from, next) => {
  // if (whiteList.indexOf(to.path) !== -1) {
  //   next()
  // }
  let token = db.get('USER_TOKEN')
  let user = db.get('USER')
  let userRouter = get('USER_ROUTER')
  if (to.path === "/mobile/upload/full/list" || to.path === "/mobile/upload/project/list" || to.path === "/mobile/upload/full/list") {
    next()
  }
  // else {
  //   if (token.length && user) {
  //     if (!asyncRouter) {
  //       if (!userRouter) {
  //         request.get(`menu/${user.username}`).then((res) => {
  //           asyncRouter = res.data
  //           save('USER_ROUTER', asyncRouter)
  //           go(to, next)
  //         })
  //       } else {
  //         asyncRouter = userRouter
  //         go(to, next)
  //       }
  //     } else {
  //       next()
  //     }
  //   } else {
  //     next('/login')
  //   }
  // }
})

function go(to, next) {
  asyncRouter = filterAsyncRouter(asyncRouter)
  router.addRoutes(asyncRouter)
  next({...to, replace: true})
}

function save(name, data) {
  localStorage.setItem(name, JSON.stringify(data))
}

function get(name) {
  return JSON.parse(localStorage.getItem(name))
}

function filterAsyncRouter(routes) {
  return routes.filter((route) => {
    let component = route.component
    if (component) {
      switch (route.component) {
        case 'MenuView':
          route.component = MenuView
          break
        case 'PageView':
          route.component = PageView
          break
        case 'EmptyPageView':
          route.component = EmptyPageView
          break
        case 'HomePageView':
          route.component = HomePageView
          break
        default:
          route.component = view(component)
      }
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children)
      }
      return true
    }
  })
}

function view(path) {
  return function (resolve) {
    import(`@/views/${path}.vue`).then(mod => {
      resolve(mod)
    })
  }
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js